import React from "react";
import { Box, BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import MessageIcon from "@mui/icons-material/Message";
import HomeIcon from "@mui/icons-material/Home";
import { useLocation, useNavigate } from "react-router-dom";
import { MobileHome } from "../Mobile/MobileHome";
import { MobilePlaybooks } from "../Mobile/MobilePlaybooks";

export default function MobileLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const isPlaybookRoute = location.pathname.startsWith("/playbook");

  const activeTab =
    location.pathname === "/"
      ? "/"
      : location.pathname.startsWith("/playbook")
        ? "/playbook"
        : location.pathname.startsWith("/messages")
          ? "/messages"
          : false;

  return (
    <Box sx={{ minHeight: "100vh", pb: 8, bgcolor: "background.default" }}>
      <Box
        component="main"
        sx={
          isPlaybookRoute
            ? {
                height: "calc(100dvh - 64px)",
                overflow: "hidden",
              }
            : { px: 2, pt: 2 }
        }
      >
        {location.pathname === "/" ? (
          <MobileHome />
        ) : location.pathname.startsWith("/playbook") ? (
          <MobilePlaybooks />
        ) : (
          children
        )}
      </Box>

      <Paper
        elevation={8}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          overflow: "hidden",
        }}
      >
        <BottomNavigation
          value={activeTab}
          onChange={(_, newValue) => navigate(newValue)}
          showLabels
        >
          <BottomNavigationAction
            label="Playbooks"
            value="/playbook"
            icon={<MenuBookIcon />}
          />
          <BottomNavigationAction label="Home" value="/" icon={<HomeIcon />} />
          <BottomNavigationAction
            label="Messages"
            value="/messages"
            icon={<MessageIcon />}
          />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}
